import React, { useEffect, useState } from "react";
import { Col, Input, Row, message, Select, Checkbox, Form, Spin } from "antd";
import { ReactComponent as SaveIcon } from "../../../assets/save-icon.svg";
import sampleImg from "../../../assets/user-icon.svg";
import { ReactComponent as EditIcon } from "../../../assets/edit-icon.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  createUser,
  fetchUserDetailsUtils,
  sendDetailsToUser,
  setUserDetailsIsEdit,
  updateUser,
} from "../redux/actions";
import CreatePasswordModal from "./createPasswordModal";
import SpinnerComponent from "../../../components/spinner";
import { isValidNumber } from "../../../globalUtils/axiosConfig";
import { capitalizeFirstLetterofEachWord } from "../../../globalUtils/capitalizeFirstLetterofEachWord";
import UpdatePasswordModal from "./updatePasswordModal";
import UseGetUserRole from "../../../components/useGetUserRole";
import axios from "axios";
import { baseURL } from "../../../globalUtils/axiosConfig";
import { getUserTimezone } from "../../../utils/timeZone";

const UserDetailsSection = ({ isUserUpdate, isProfileCase, canUpdate }) => {
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [userProfileImg, setUserProfileImg] = useState(null);
  const [isUserImgSelected, setIsUserImgSelected] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [pinModalOpen, setPinModalOpen] = useState(false);
  const [utils, setUtils] = useState({});
  const [currentUser, setCurrentUser] = useState({});
  const [pin, setPin] = useState("");
  const [attachmentBlobUrl, setAttachmentBlobUrl] = useState(null);

  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;

  const {
    createUserLoading,
    currentUserObj,
    userDetailsIsEdit,
    utilsData,
    sendDetailLoading,
  } = useSelector((state) => state.userManagerReducer);
  
  const { allDepartments } = useSelector((state) => state.departmentReducer);

  const [isSuperAdmin] = UseGetUserRole();

  useEffect(() => {
    // dispatch(fetchUserDetailsUtils());
  }, []);

  // Fetch attachment and create blob URL when currentUserObj changes
  useEffect(() => {
    if (currentUserObj?.attachments?.[0]?.path) {
      fetchAttachmentAndCreateBlobUrl(currentUserObj.attachments[0]);
    }
  }, [currentUserObj]);

  // Function to fetch attachment and create blob URL
  const fetchAttachmentAndCreateBlobUrl = async (attachment) => {
    try {
      // Create full URL for the attachment using the specific endpoint
      const attachmentUrl = `${baseURL}/attachments/${attachment.id}`;
      
      // Fetch the attachment
      const response = await axios({
        url: attachmentUrl,
        method: 'GET',
        responseType: 'blob',
      });
      
      // Get the mime type
      const mimeType = response.headers['content-type'] || 'application/octet-stream';
      
      // Create blob and URL
      const blob = new Blob([response.data], { type: mimeType });
      const blobUrl = window.URL.createObjectURL(blob);
      
      // Set the blob URL in state
      setAttachmentBlobUrl(blobUrl);
    } catch (error) {
      console.error('Error fetching attachment:', error);
      message.error(`Failed to load attachment: ${error.response?.data?.message || error.message}`);
    }
  };

  useEffect(() => {
    form.setFieldsValue(currentUserObj);
    setCurrentUser(currentUserObj);
    if (
      typeof currentUserObj?.userType === "number" &&
      utilsData?.user_types?.length > 0
    ) {
      let item = utilsData.user_types.filter(
        (el) => el.value === currentUserObj?.userType
      )[0];
      let statusItem = utilsData.status.filter(
        (el) => el.value === currentUserObj?.status
      )[0];
      setCurrentUser({
        ...currentUserObj,
        userType: item.key,
        status: statusItem.key,
      });

      form.setFieldsValue({
        ...currentUserObj,
        userType: item.key,
        status: statusItem.key,
      });
    } else {
      setCurrentUser(currentUserObj);
      form.setFieldsValue(currentUserObj);
    }
    setUtils(utilsData);
  }, [currentUserObj, utilsData]);

  useEffect(() => {
    setLoading(createUserLoading);
    // if (createUserLoading) {
    //   setIsUserImgSelected(false);
    // }
  }, [createUserLoading]);

  useEffect(() => {
    setIsEdit(userDetailsIsEdit);
  }, [userDetailsIsEdit]);

  const changeHandler = (event) => {
    const image = event.target.files[0];
    if (!image) {
      return false;
    }
    if (!image.name.match(/\.(jpg|jpeg|png)$/)) {
      message.error("Photo should be png or jpg format.");
      return false;
    }
    if (image.size > 5120000) {
      message.error("Photo size should be less than 5MB.");
      return false;
    }
    setUserProfileImg(event.target.files[0]);
    // handleChange("image", event.target.files[0]);
    setIsUserImgSelected(true);
  };

  const onChange = (value) => {
    // console.log(`selected ${value}`);
  };

  const onFinish = (values) => {
    if (password?.length < 6 && !isUserUpdate) {
      return message.error("Password is required");
    }

    const timezone = getUserTimezone();

    isUserUpdate
      ? dispatch(
          updateUser({
            ...values,
            ...(password.length > 5 && { password }),
            ...(userProfileImg && { image: userProfileImg }),
            id: currentUserObj.id,
            timezone,
          })
        )
      : dispatch(
          createUser({
            ...values,
            password,
            image: userProfileImg,
            timezone,
          })
        );
  };

  const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };

  const handleSave = () => {
    form.submit();
  };

  const capitalizeFirstLetter = (str) =>
    str && str.charAt(0).toUpperCase() + str.slice(1);

  return (
    <>
      {isUserUpdate ? (
        <UpdatePasswordModal
          isVisible={passwordModalOpen}
          setVisible={setPasswordModalOpen}
          email={currentUserObj.email}
          isClient={false}
          userId={currentUserObj.id}
        />
      ) : (
        <CreatePasswordModal
          setPassword={setPassword}
          isVisible={passwordModalOpen}
          setVisible={setPasswordModalOpen}
          isUpdate={isUserUpdate}
        />
      )}
      <Row>
        <Col span={24} className="heading-col">
          <Row align="middle" justify="space-between">
            <Col>
              <div>
                <span className="heading-span user-details-heading">USER DETAILS</span>
              </div>
            </Col>
            <Col>
              {isEdit ? (
                loading ? (
                  <SpinnerComponent fontSize={14} />
                ) : (
                  <SaveIcon className="save-icon" width={16} height={16} onClick={handleSave} />
                )
              ) : (
                (isProfileCase || canUpdate) && (
                  <EditIcon
                    width={16}
                    fill="#ed017f"
                    height={16}
                    onClick={() => dispatch(setUserDetailsIsEdit(true))}
                  />
                )
              )}
            </Col>
          </Row>
        </Col>
        <Col
          span={24}
          className={`user-details-section ${!isEdit && "is-edit"}`}
        >
          <Row justify="start">
            <Col md={5} lg={5} xl={5} xxl={4} className="photo-col">
              <div>
                <span>PHOTO</span>
                <div className={`img-parent-div ${isEdit && "edit-image"}`}>
                  <div className="img-nested-div">
                    <img
                      width="100%"
                      height="100%"
                      src={
                        isUserImgSelected
                          ? URL.createObjectURL(userProfileImg)
                          : attachmentBlobUrl
                          ? attachmentBlobUrl
                          : sampleImg
                      }
                      alt="user-profile"
                    />
                  </div>
                  {isEdit && (
                    <div className="edit-icon-div">
                      <input
                        readOnly={loading}
                        disabled={!isEdit}
                        type="file"
                        name="profileImg"
                        id="profileImg"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={changeHandler}
                      />
                      <label htmlFor="profileImg">
                        <EditIcon height={14} width={14} fill="#ed017f" />
                      </label>
                    </div>
                  )}
                </div>
                {isEdit && (
                  <div className="text-div">
                    <span className="text">
                      Upload a JPG or PNG file.
                      <br />
                      Recommended image size 800 x 800: Max 5 MB{" "}
                    </span>
                  </div>
                )}
              </div>
            </Col>
            <Col
              md={isEdit ? 19 : 15}
              lg={isEdit ? 19 : 15}
              xl={isEdit ? 19 : 15}
              xxl={16}
            >
              <Form
                {...formItemLayout}
                form={form}
                name="user-details"
                onFinish={onFinish}
                initialValues={currentUser}
                scrollToFirstError
                labelWrap={true}
                layout="horizontal"
                className="user-detail-form"
                requiredMark={false}
              >
                <Row gutter={[30, 0]}>
                  <Col md={12} lg={12} xl={12} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                      ]}
                      name="firstName"
                      label="First Name"
                    >
                      <Input
                        readOnly={loading}
                        disabled={!isEdit || !canUpdate}
                        placeholder="First Name"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12} lg={12} xl={12} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required",
                        },
                      ]}
                      name="lastName"
                      label="last name"
                    >
                      <Input
                        readOnly={loading}
                        disabled={!isEdit || !canUpdate}
                        placeholder="Last Name"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12} lg={12} xl={12} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                        { pattern: isValidNumber, message: "Invalid" },
                        {
                          min: 6,
                          message: "Should contain at least 6 characters.",
                        },
                        {
                          max: 13,
                          message:
                            "Should not contain more than 13 characters.",
                        },
                      ]}
                      name="idNumber"
                      label="ID Number"
                    >
                      <Input
                        readOnly={loading}
                        disabled={!isEdit || !canUpdate}
                        placeholder="ID Number"
                      />
                    </Form.Item>
                  </Col>
                  {/* <Col md={12} lg={12} xl={12} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                      ]}
                      name="department_name"
                      label="department"
                    >
                      <Input
                        readOnly={loading}
                        disabled={
                          !isEdit ||
                          // isUserUpdate ||
                          !canUpdate ||
                          isProfileCase
                        }
                        placeholder="Departments"
                      />
                    </Form.Item>
                  </Col> */}

                  <Col md={12} lg={12} xl={12} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                        { pattern: isValidNumber, message: "Invalid" },
                      ]}
                      name="contactNumber"
                      label="Contact Number"
                    >
                      <Input
                        readOnly={loading}
                        disabled={!isEdit || !canUpdate}
                        placeholder="Contact Number"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12} lg={12} xl={12} xxl={8}>
                    <Form.Item
                      name="email"
                      label="Email Address"
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                        {
                          type: "email",
                          message: "The input is not valid Email!",
                        },
                      ]}
                    >
                      <Input
                        readOnly={loading}
                        disabled={!isEdit || !canUpdate} // || isUserUpdate
                        placeholder="Email Address"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12} lg={12} xl={12} xxl={8}>
                    <label>password</label>
                    <div
                      className="password-div"
                      style={{
                        cursor: !isEdit && "text",
                      }}
                    >
                      <span
                        onClick={() => isEdit && setPasswordModalOpen(true)}
                      >
                        {`${isUserUpdate ? "Change" : "Create"} Password`}
                      </span>
                    </div>
                  </Col>

                  <Col md={12} lg={12} xl={12} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                      ]}
                      name="departmentId"
                      label="Department"
                    >
                      <Select
                        style={{
                          width: "100%",
                        }}
                        disabled={!isEdit || !canUpdate}
                        readOnly={true}
                        className="department-select"
                        dropdownClassName="select-dropdown-custom"
                        getPopupContainer={() =>
                          document.getElementsByClassName(
                            "ant-layout-content layout-content site-layout-background custom-textarea"
                          )[0]
                        }
                        showSearch
                        placeholder="Select Department"
                        optionFilterProp="children"
                        onChange={onChange}
                        // onSearch={onSearch}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {allDepartments.map(({ id, name }) => {
                          return (
                            <Option key={id} value={id}>
                              {capitalizeFirstLetter(name || "")}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>

                  <Col md={12} lg={12} xl={12} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                      ]}
                      name="jobTitle"
                      label="Job Title"
                    >
                      <Input
                        readOnly={loading}
                        disabled={!isEdit || !canUpdate}
                        placeholder="Job Title"
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12} lg={12} xl={12} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                        // { pattern: isValidNumber, message: "Invalid" },
                      ]}
                      name="employeeNumber"
                      label="Employee Number"
                    >
                      <Input
                        readOnly={loading}
                        disabled={!isEdit || !canUpdate}
                        placeholder="Employee Number"
                      />
                    </Form.Item>
                  </Col>

                  {/* {!isProfileCase && ( */}
                  <Col md={12} lg={12} xl={12} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                      ]}
                      name="userType"
                      label="user type"
                    >
                      <Select
                        style={{
                          width: "100%",
                        }}
                        disabled={!isEdit || !canUpdate}
                        className="department-select"
                        dropdownClassName="select-dropdown-custom"
                        getPopupContainer={() =>
                          document.getElementsByClassName(
                            "ant-layout-content layout-content site-layout-background custom-textarea"
                          )[0]
                        }
                        showSearch
                        placeholder="Select User Type"
                        optionFilterProp="children"
                        // onSearch={onSearch}
                        filterOption={(input, option) =>
                          option.children.some((item) =>
                            item
                              .toLocaleLowerCase()
                              .includes(input.toLocaleLowerCase())
                          )
                        }
                      >
                        {[
                          { key: "super_admin" },
                          { key: "user" },
                        ].map(({ key }) => {
                          return (
                            <Option key={key} value={key}>
                              {capitalizeFirstLetterofEachWord(key || "")}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col md={12} lg={12} xl={12} xxl={8}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                      ]}
                      name="status"
                      label="status"
                    >
                      <Select
                        style={{
                          width: "100%",
                        }}
                        disabled={!isEdit || !canUpdate}
                        readOnly={true}
                        className="department-select"
                        dropdownClassName="select-dropdown-custom"
                        getPopupContainer={() =>
                          document.getElementsByClassName(
                            "ant-layout-content layout-content site-layout-background custom-textarea"
                          )[0]
                        }
                        showSearch
                        placeholder="Select Status"
                        optionFilterProp="children"
                        onChange={onChange}
                        // onSearch={onSearch}
                        filterOption={(input, option) =>
                          option.children
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {[{ key: "active" }, { key: "inactive" }].map(
                          ({ key }) => {
                            return (
                              <Option key={key} value={key}>
                                {capitalizeFirstLetter(key || "")}
                              </Option>
                            );
                          }
                        )}
                      </Select>
                    </Form.Item>
                  </Col>

                  {/* )} */}
                </Row>
              </Form>
            </Col>

            {currentUserObj?.id && !isProfileCase && !isEdit && (
              <Col span={4}>
                <div className="send-details-parent-div">
                  <Spin
                    spinning={sendDetailLoading}
                    className={`send-details-div`}
                  >
                    <div
                      className={`send-details-div ${
                        sendDetailLoading && "disabled-onclick"
                      }`}
                      onClick={() =>
                        dispatch(sendDetailsToUser(currentUserObj.id))
                      }
                    >
                      <span>Send Login</span>
                      <span>Details to User</span>
                    </div>
                  </Spin>
                </div>
              </Col>
            )}
          </Row>
        </Col>
      </Row>
      <div className="empty-div"></div>
    </>
  );
};

export default UserDetailsSection;